export enum AttachmentType {
  INVOICE = 1,
  QUOTE = 2,
}
